import request from '../../../common/request/index.js'
const api = request.api

export default {
  page: (params) => {
    return api.post('card/card/page', params)
  },
  get: (id) => {
    return api.get(`card/card/${id}`)
  },
  create: (data) => {
    return api.post('card/card', data)
  },
  update: (data) => {
    return api.put('card/card', data)
  },
  copy: (params) => {
    return api.post('card/card/copy', params)
  },
  delete: (id) => {
    return api.delete(`card/card/${id}`)
  },
  // 入网申请
  onboard: (cardId) => {
    return api.post('card/card/onboard', { cardId });
  },
  // 查询入网详情
  onboardDetail: (cardId) => {
    return api.get('card/card/onboard/detail', { cardId });
  },
  // ===== 新增导出方法 =====
  export: (params) => {
    return api.post('card/card/export', params, { responseType: 'blob' })
  },
  // ===== 钱包相关方法 =====
    walletRegister: (params) => {
      return api.post('card/card/wallet/register', params)
    },
	walletInfo: (params) => {
	  return api.get('card/card/wallet/info', params)
	},
    walletBind: (params) => {
      return api.post('card/card/wallet/bind', params)
    },
    walletSmsConfirm: (params) => {
      return api.post('card/card/wallet/sms/confirm', params)
    },
	// 申请签约
	walletContractSign: (params) => {
	  return api.post('card/card/wallet/contract/sign', params)
	},
	// 查询余额
	walletBalance: (params) => {
	  return api.get('card/card/wallet/balance', params)
	},
	walletTransfer: (params) => {
	  return api.post('card/card/wallet/transfer', params)
	},
	walletTransferQuery: (params) => {
	  return api.get('card/card/wallet/transfer/query', params)
	},
}